/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizer.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }
let lastFocusedQtyButton = null; // Stores which qty button was last clicked
/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
  var params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status  + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback)
{
	
	if((parseInt($("#Quantity").val()) + CART_COUNT) > parseInt($("#quantity-max").val()))
	{
		alert("We're sorry. This product has a maximum purchase count of " + $("#quantity-max").val() + ".");
		$("#Quantity").val((parseInt($("#quantity-max").val())-CART_COUNT));
		if($("#Quantity").val() == 0) $("#Quantity").val(1);
		return false;
	}
	CART_COUNT += parseInt($("#Quantity").val());
	
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: jQuery(form).serialize(),
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item, form);
      }
      else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
    }
  };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    }
    else {
      ShopifyAPI.onCartUpdate(cart);
    }
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(variant_id, quantity, callback) {
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data:  'quantity='+quantity+'&id='+variant_id,
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

  'use strict';

  // Public functions
  var init, loadCart,adjustCartCallback;

  // Private general variables
  var settings, $body, variant_set_id, variant_set_qty;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

  // Private functions
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {

    // Default settings
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      cartContainer      : '#CartContainer',
      addToCartSelector  : 'input[type="submit"]',
      cartCountSelector  : null,
      cartCostSelector   : null,
      moneyFormat        : '$',
      disableAjaxCart    : false,
      enableQtySelectors : true
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);

    // General Selectors
    $body = $('body');

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
  };

  loadCart = function () {
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');

      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
    }
  };

  formOverride = function () {
    $formContainer.on('submit', function(evt) {
      evt.preventDefault();

      // Add class to be styled if desired
      $addToCart.removeClass('is-added').addClass('is-adding');

      // Remove any previous quantity errors
      $('.qty-error').remove();

      ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
    });
  };

 itemAddedCallback = function (product) {
    $addToCart.removeClass('is-adding').addClass('is-added');

    ShopifyAPI.getCart(function(cart) { // The anonymous callback is essential
        cartUpdateCallback(cart);       // Update the visual cart
        setTimeout(function() {       // Introduce a tiny delay
        updateCartStatusMessage(product, cart); // Update the accessible status message
          }, 10); // 10 milliseconds delay - adjust if needed
    });
};

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');

    if (!!data.message) {
      if (data.status == 422) {
        var error_description = data.description;
        error_description = "This product is out of stock.";
        $formContainer.after('<div class="errors qty-error">'+ error_description +'</div>')
      }
    }
  };

function updateCartStatusMessage(product, cart) {
    const cartStatus = document.getElementById('CartCount'); // Or your actual ID
  const statusMessageDiv = document.getElementById('cart-status-message'); // Hidden element
    if (cartStatus && statusMessageDiv) { // Check BOTH elements exist
        const itemName = product.title; // Or product.name (check your product object)
        const itemCount = cart.item_count;

        const message = `Added to cart. Shopping Cart, ${itemCount} items`; // Customize
        cartStatus.textContent = message;
statusMessageDiv.textContent = message; // Update the visually hidden div for screen readers
        setTimeout(() => {
            cartStatus.textContent = `Shopping Cart, ${itemCount} items`; // Reset (optional)
        }, 5000);
    } else {
        console.error("Cart status element not found! Check your HTML."); // Debugging message
    }
}



  cartUpdateCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);
    buildCart(cart);
  };

  buildCart = function (cart) {
    // Start with a fresh cart div
    $cartContainer.empty();

    // Show empty cart
    if (cart.item_count === 0) {
      $cartContainer
        .empty()
       .append('<div id="empty-cart-message" aria-live="polite"><p>' + "Your cart is currently empty." + '</p></div>');
      cartCallback(cart);
      return;
    }

    // Handlebars.js cart layout
    var items = [],
        item = {},
        data = {},
        source = $("#CartTemplate").html(),
        template = Handlebars.compile(source);

    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {
      var itemAdd = cartItem.quantity + 1,
          itemMinus = cartItem.quantity - 1,
          itemQty = cartItem.quantity;		  

      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
      */

      if (cartItem.image != null){
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_small$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }

      var prodName = cartItem.product_title,
          prodVariation = cartItem.variant_title;

      if (prodVariation == 'Default Title') {
        prodVariation = false;
      }

      // Create item's data object and add to 'items' array
      item = {
        id: cartItem.variant_id,		
		product_id: cartItem.product_id,		
        url: cartItem.url,
        img: prodImg,
        name: prodName,
        name_encoded: escapeHtml(prodName),
		qty_max: cartItem.properties._qtymax,
        variation: prodVariation,
        itemAdd: itemAdd,
        itemMinus: itemMinus,
        itemQty: itemQty,
        price: Shopify.formatMoney(cartItem.price, settings.moneyFormat),
        vendor: cartItem.vendor
      };

      items.push(item);
    });

    // Gather all cart data and add to DOM
    data = {
      items: items,
      note: cart.note,
      itemCount: cart.item_count,
      totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat)
    }

// In buildCart
$cartContainer.append(template(data));
$(".ajaxcart__qty-num").attr('readonly','readonly');

// Call the callback BEFORE resetting focus tracking
cartCallback(cart);

// ✅ Now safe to reset
lastFocusedQtyButton = null;


  }


cartCallback = function(cart) {
  $body.removeClass('drawer--is-loading');
  $body.trigger('ajaxCart.afterCartLoad', cart);

  if (lastFocusedQtyButton) {
    const $oldButton = $(lastFocusedQtyButton);
    const itemId = $oldButton.data('id');
    const isPlus = $oldButton.hasClass('ajaxcart__qty--plus');
    const classSelector = isPlus ? '.ajaxcart__qty--plus' : '.ajaxcart__qty--minus';
    const $newButton = $(`${classSelector}[data-id="${itemId}"]`);

    if ($newButton.length) {
      $newButton.focus();
    }
  } else {
    // Fallback: only focus close button if no previous qty button
    var closeButton = $('#CartDrawer .js-drawer-close button');
    if (closeButton.length) {
      closeButton.focus();
    }
  }

  // Update status message
  if (cart.item_count === 0) {
    jQuery("#cart-status-message").text("Your cart is empty.");
  } else {
    jQuery("#cart-status-message").text("");
  }

  // Finally, reset the focus tracker
  lastFocusedQtyButton = null;
};



  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function() {
       lastFocusedQtyButton = this; // Save reference to the clicked button
      var el = $(this),
          id = el.data('id'),
		  product_url = el.data('url'),
		  qty_max = el.data('qty-max'),
          qtySelector = el.siblings('.ajaxcart__qty-num'),
          qty = parseInt(qtySelector.val().replace(/\D/g, ''));
		  		  
      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if (el.hasClass('ajaxcart__qty--plus'))
	  {
		if(parseInt(qty+1) > qty_max)
		{
			alert("We're sorry. This product has a maximum purchase count of " + $("#quantity-max").val() + ".");
			return false;
		}
		else			
		  qty = qty + 1;
      } else {
        qty = qty - 1;
        if (qty <= 0) qty = 0;
		if(typeof THIS_PRODUCT != "undefined" && $(this).data('product-id') == THIS_PRODUCT)
			CART_COUNT = qty;
      }

      // If it has a data-id, update the cart.
      // Otherwise, just update the input's number
      if (id) {
        updateQuantity(id, qty);
      } else {
        qtySelector.val(qty);
      }
    });

    // Update quantity based on input on change
    $body.on('change', '.ajaxcart__qty-num', function() {
      var el = $(this),
          id = el.data('id'),
		  qty_max = el.data('qty-max'),
          qty = parseInt(el.val().replace(/\D/g, ''));

      var qty = validateQty(qty);
	  
	if(parseInt(qty+1) > qty_max)
	{
		alert("We're sorry. This product has a maximum purchase count of " + $("#quantity-max").val() + ".");
		return false;
	}

      // Only update the cart via ajax if we have a variant ID to work with
      if (id) {
        updateQuantity(id, qty);
      }
    });

// Handle direct removal via the .cart-remove button
    $body.on('click', '.cart-remove', function(e) {
      e.preventDefault();

      var el = $(this),
          id = el.data('id'); // Get the variant ID from the data-id attribute

      // Directly call updateQuantity with a quantity of 0 to remove the item
      updateQuantity(id, 0);
    });

    
    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var el = $(this);
      setTimeout(function() {
        el.select();
      }, 50);
    });

    function updateQuantity(id, qty) {
      // Add activity classes when changing cart quantities
      var row = $('.ajaxcart__row[data-id="' + id + '"]').addClass('is-loading');

      if (qty === 0) {
        row.parent().addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      variant_set_qty = qty;
	  variant_set_id = id;
      setTimeout(function() {
        ShopifyAPI.changeItem(id, qty, adjustCartCallback);
      }, 250);
    }

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function(cart) {});
    });
  };

  adjustCartCallback = function (cart) {
    //console.log(variant_set_id);
    //console.log(variant_set_qty);
    //console.log(cart);
    
    var this_cart_item;
    for(var cart_item in cart.items)
    {
      this_cart_item = cart.items[cart_item];
      if(this_cart_item.variant_id == variant_set_id && this_cart_item.quantity < variant_set_qty)
      {
        alert("This product is out of stock.");
        break;
      }
    }
    
    // Update quantity and price
    updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      ShopifyAPI.getCart(buildCart);
    }, 150)
  };

  createQtySelectors = function() {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function() {
        var el = $(this),
            currentQty = el.val();

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#AjaxQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus
            };

        // Append new quantity selector then remove original
        el.after(template(data)).remove();				
      });
    }

    // If there is a regular link to remove an item, add attributes needed for ajax
    if ($('a[href^="/cart/change"]', $cartContainer).length) {
      $('a[href^="/cart/change"]', $cartContainer).each(function() {
        var el = $(this).addClass('ajaxcart__remove');
      });
    }
  };

  qtySelectors = function() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]');

    if (numInputs.length) {
      numInputs.each(function() {
        var el = $(this),
            currentQty = el.val(),
            inputName = el.attr('name'),
            inputId = el.attr('id');

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#JsQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId
            };

        // Append new quantity selector then remove original
        el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input	
	$(".js-qty__num").attr('readonly','readonly');
      $('.js-qty__adjust').on('click', function() {
        var el = $(this),
            id = el.data('id'),
            qtySelector = el.siblings('.js-qty__num'),
            qty = parseInt(qtySelector.val().replace(/\D/g, ''));

        var qty = validateQty(qty);

        // Add or subtract from the current quantity
        if (el.hasClass('js-qty__adjust--plus'))
		{
			if(parseInt(qty+1+CART_COUNT) > parseInt($("#quantity-max").val()))
				alert("We're sorry. This product has a maximum purchase count of " + $("#quantity-max").val() + ".");
			else			
			  qty = qty + 1;
        } else {
          qty = qty - 1;
          if (qty <= 1) qty = 1;
        }

        // Update the input's number
        qtySelector.val(qty);	
           // Announce the new quantity for screen readers
      qtySelector.attr('aria-live', 'polite');
      qtySelector.attr('aria-label', 'Quantity: ' + qty);
      setTimeout(function() {
        qtySelector.removeAttr('aria-live'); // Optionally remove after a short delay
      }, 500);
      });
    }
  };



  validateQty = function (qty) {

    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    load: loadCart,
	adjustCartCallback: adjustCartCallback
  };

  return module;

}(ajaxCart || {}, jQuery));